module.exports = __webpack_public_path__ + "static/media/video_aiPlato_Proficiency_Curve_vs_Traditional_v2.1c028cc6.mp4";